import React, { Component } from 'react';
import translations from 'translations/terms.json';
import Moment from 'moment';

export const I18nContext = React.createContext({});

export class I18nProvider extends Component {

	constructor (props) {
		super(props);

		const currentLanguage = props.currentLanguage || 'en';
		Moment.locale(currentLanguage);

		this.state = {
			currentLanguage: currentLanguage
		};
	}


	/**
	 * translate
	 */
	t = (term) => {
		const { currentLanguage } = this.state;

		return translations[term][currentLanguage];
	}


	setCurrentLanguage = (language) => {
		this.setState({
			currentLanguage: language
		});
		Moment.locale(language);
	}


	/**
	 * The render function
	 */
	render () {
		const { children, languages } = this.props;

		return (
			<I18nContext.Provider
				value={{
					t: this.t,
					currentLanguage: this.state.currentLanguage,
					setCurrentLanguage: this.setCurrentLanguage,
					languages: languages
				}}
			>
				{ children }
			</I18nContext.Provider>
		);
	}
}

export const I18nConsumer = I18nContext.Consumer;
